// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__mHJYi","paramInput":"JobSimulator_paramInput__MAgp5","input":"JobSimulator_input__3f8dE"};